export const getAnnouncementPicturesCount = (announcement: any): number => {
  const pictures = Array.isArray(announcement?.pictures)
    ? announcement.pictures.filter(Boolean)
    : [];

  const picturesLength = pictures.length;
  const rawCount = Number(announcement?.picturesNbr);
  const hasValidCount = Number.isFinite(rawCount) && rawCount >= 0;

  if (hasValidCount && rawCount > 0) return rawCount;
  if (picturesLength > 0) return picturesLength;
  if (hasValidCount) return rawCount;

  return 0;
};
